
import { useDispatch, useSelector } from 'react-redux'

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete'

import './autocomplete.css';
import { iniChangeItemsName } from '../../../redux/actions/pptos';

export const AutocompleteCategorias = ({ itemsOptions, item }) => {

    const dispatch = useDispatch()
    const { items } = useSelector(state => state.ppto.detail)

    const handleChange = (e, newValue, item) => {
        const { target } = e

        let values = {
            tipo: item.tipo,
            id_titulo: 0,
            nombre: '',
            id_categoria: 0,
            id_servicio: 0
        }

        if (e.type !== 'blur') {
            const newName = ((newValue.codigo !== '' && newValue.codigo !== null) ? `${newValue.nombre} / ${newValue.codigo}` : newValue.nombre)
            values = {
                ...values,
                nombre: newName,
                id_categoria: newValue.id
            }
        }

        if (e.type === 'blur') {
            values = {
                ...values,
                nombre: target.value,
                id_categoria: item.id_categoria
            }
        }

        dispatch(iniChangeItemsName(items, values, item))

    }

    return (
        <div className="box-autocomplete title">
            <Autocomplete
                id="free-solo-demo"
                freeSolo
                // value={itemsOptions.find(it => it.id === item.id_categoria) || ''}
                value={item.nombre || ''}
                renderInput={(params) => <TextField {...params} placeholder='Categoría' />}
                onChange={(e, newValue) => handleChange(e, newValue, item)}
                onBlur={(e, newValue) => handleChange(e, newValue, item)}
                options={itemsOptions}
                getOptionLabel={(option) => {

                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }

                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }

                    // Regular option
                    return option.codigo ? (option.nombre + " / " + option.codigo) : option.nombre
                }}
            />
        </div>
    );
}